import type * as featureTypes from '@viamrobotics/web-client/feature/v1/feature';

import { assertExhaustive } from '$lib/assert';

import type { FeatureFlags } from './feature';

export const getFeatureFlags = (
  features: featureTypes.Feature[] = []
): FeatureFlags => {
  return Object.fromEntries(
    features.map((feature) => [feature.id, protoToValue(feature)])
  );
};

const protoToValue = (
  value: featureTypes.Feature
): boolean | number | string | undefined => {
  const switchVal = value.value.oneofKind;
  switch (switchVal) {
    case 'stringValue': {
      return value.value.stringValue;
    }
    case 'boolValue': {
      return value.value.boolValue;
    }
    case 'floatValue': {
      return value.value.floatValue;
    }
    case undefined: {
      return undefined;
    }
    default: {
      return assertExhaustive(switchVal);
    }
  }
};
